var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    display_off:
      _vm.location != 'namya.app' &&
      _vm.location != 'localhost:8080' &&
      _vm.location != 'www.xn--mgba3gc68d.com',
  }},[_c('Navbar'),_c('Filters'),_c('bottommenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }